import {
  apply, call, delay, fork, put, select,
} from 'redux-saga/effects';
import {
  getClientAlias, getLanguage, getMatchStatus, getShowOdds,
} from '../../reducers';
import { BetstopConfigRequest } from '../../../lib/betstop-api';
import { pollFishnet, pollTillResponse } from '../utilLCR';
import { sagaCancel, sagaRunning } from '../utilSagas';
import { isEnded, isLive, isNotStarted } from '../../utils/matchstatus';
import updateBetstop from '../../actions/betstop';
import {
  LIVE_BETSTOP_POLL_INTERVAL,
  PREMATCH_BETSTOP_POOL_INTERVAL,
} from '../../constants/fishnet';

function* loadBetstop(matchId, specifier = false, isBookmaker) {
  const showOdds = yield select(getShowOdds);
  if (!showOdds) {
    return;
  }
  const clientAlias = yield select(getClientAlias);
  const language = yield select(getLanguage);

  let request;
  if (isBookmaker) {
    request = new BetstopConfigRequest(matchId, null, clientAlias, language);
  } else {
    request = new BetstopConfigRequest(matchId, specifier, clientAlias, language);
  }
  const betstop = yield apply(request, request.get);

  yield put(updateBetstop(betstop));
}

function* pollBetstopConfig(matchId) {
  let status;
  let taskPre;
  let taskLive;

  yield call(pollTillResponse, { logLevel: 5 }, loadBetstop, matchId, null, true); // atleast once

  while (true) {
    status = yield select(getMatchStatus, matchId);

    if (!sagaRunning(taskPre) && isNotStarted(status)) {
      taskPre = yield fork(
        pollFishnet,
        { pollInterval: PREMATCH_BETSTOP_POOL_INTERVAL },
        loadBetstop,
        matchId,
        false, // prematch
      );
    } else if (!sagaRunning(taskLive) && isLive(status)) {
      taskPre = sagaCancel(taskPre);
      taskLive = yield fork(
        pollFishnet,
        { pollInterval: LIVE_BETSTOP_POLL_INTERVAL },
        loadBetstop,
        matchId,
        true, // live
      );
    } else if (isEnded(status)) {
      yield delay(PREMATCH_BETSTOP_POOL_INTERVAL + 1000); // 5 seconds
      taskPre = sagaCancel(taskPre);
      taskLive = sagaCancel(taskLive);
    }
  }
}

export default pollBetstopConfig;
